//NODE_ENV='development'
//NODE_ENV='production' automatically declared

export const baseURL=process.env.NODE_ENV==='production'? '/api':'http://localhost:5000/api'
// export const baseURL='http://localhost:5000/api'
// console.log(process.env.NODE_ENV)
// export const baseURL='http://localhost:5000/api'